import { ArrowUpRight } from "lucide-react";

export const fadeUp = {
    hidden: { opacity: 0, y: 24 },
    show: (i = 0) => ({
        opacity: 1,
        y: 0,
        transition: { duration: 0.7, delay: i * 0.08, ease: [0.2, 0.7, 0.2, 1] },
    }),
};

export const SectionLabel = ({ num, label }) => (
    <div className="flex items-center gap-4">
        <span className="section-num tabular">{num}</span>
        <span className="h-px w-10 bg-[#0D7A73]" />
        <span className="font-mono-label text-xs text-slate-600">{label}</span>
    </div>
);

export const PrimaryCTA = ({ children, href = "#kapcsolat", testId, dark = false }) => (
    <a
        href={href}
        data-testid={testId}
        className={`group inline-flex items-center gap-3 px-8 py-4 font-display font-bold text-base sm:text-lg border-2 ${
            dark
                ? "bg-white text-[#0A0A0A] border-white hover:bg-[#0D7A73] hover:text-white hover:border-[#0D7A73]"
                : "bg-[#0D7A73] text-white border-[#0D7A73] hover:bg-[#0A5E58] hover:border-[#0A5E58]"
        } transition-colors duration-300`}
    >
        {children}
        <ArrowUpRight className="cta-arrow w-5 h-5" strokeWidth={2.5} />
    </a>
);

export const SecondaryCTA = ({ children, href = "#szolgaltatasok", testId, light = false }) => (
    <a
        href={href}
        data-testid={testId}
        className={`group inline-flex items-center gap-3 px-8 py-4 font-display font-bold text-base sm:text-lg border-2 transition-colors duration-300 ${
            light
                ? "border-white/60 text-white hover:bg-white hover:text-[#0A0A0A]"
                : "border-[#0A0A0A] text-[#0A0A0A] hover:bg-[#0A0A0A] hover:text-white"
        }`}
    >
        {children}
        <ArrowUpRight className="cta-arrow w-5 h-5" strokeWidth={2.5} />
    </a>
);
